export default {
  isTourbuzz: () => {
    return window.location.hostname.indexOf("tourbuzz.net") !== -1;
  },
  isMyUrbanimmersive: () => {
    return window.location.hostname.indexOf("my.urbanimmersive.com") !== -1;
  },
  isCustomDomain: () => {
    return (
      window.location.hostname.indexOf("tourbuzz.net") === -1 &&
      window.location.hostname.indexOf("my.urbanimmersive.com") === -1
    );
  },
  isClientPanel: () => {
    return window.location.pathname.startsWith("/panel/client");
  },
  isImmersive3dTourPanel: () => {
    return window.location.pathname.startsWith("/panel/immersive-3d-tour");
  },
};
